import { render, staticRenderFns } from "./VendorFormModal.vue?vue&type=template&id=18374b89&"
import script from "./VendorFormModal.vue?vue&type=script&lang=js&"
export * from "./VendorFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports